import { atom } from 'jotai';

import { NMIResolutionState } from '@origin-digital/nmi-resolution';

export const nmiResolutionStateAtom = atom<NMIResolutionState | undefined>();
